import Alert from 'components/UI/Alert'
import { createConfirmation } from 'react-confirm'

const defaultConfirmation = createConfirmation(Alert);

export const alert = {
	message: (text, title, options = {}) => {
		return defaultConfirmation({ 
			text, 
			title, 
			alertType: "message",
			...options 
		});
	},
	fail: (text, title, options = {}) => {
		return defaultConfirmation({ 
			text, 
			title, 
			alertType: "fail",
			...options 
		});
	},
	warning: (text, title, options = {}) => {
		return defaultConfirmation({ 
			text, 
			title, 
			alertType: "warning",
			...options 
		});
	},
	success: (text, title, options = {}) => {
		return defaultConfirmation({ 
			text, 
			title, 
			alertType: "success",
			...options 
		});
	},
	error: (text, title, options = {}) => {
		return defaultConfirmation({ 
			text, 
			title, 
			alertType: "error",
			...options 
		});
	},
}

export default alert



// WEBPACK FOOTER //
// ./src/util/alert.js